import { render, staticRenderFns } from "./BookingDetailView.vue?vue&type=template&id=7349feda&scoped=true"
import script from "./BookingDetailView.vue?vue&type=script&lang=ts"
export * from "./BookingDetailView.vue?vue&type=script&lang=ts"
import style0 from "./BookingDetailView.vue?vue&type=style&index=0&id=7349feda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349feda",
  null
  
)

export default component.exports